import {
  Combobox,
  DropdownButton,
  Icons,
  ToggleButton
} from '@eggplant/pattern-library'
import type {
  ButtonShape,
  Options
} from '@eggplant/types'
import type { CSSProperties } from 'react'
import {
  FaCheck,
  FaTimes
} from 'react-icons/fa'

interface Props {
  value: string
  onChange: (value: string) => void
}

const paddingStyle: CSSProperties = {
  padding: '8px 12px'
}

const connectionOptions: Options = []

const SelectConnectionStatus = ({
  value,
  onChange
}: Props) => {
  const getRenderButton = (_options: Options) => (buttonProps: ButtonShape) =>
    <DropdownButton
      {...buttonProps}
      Icon={Icons.Union}
      isFilter
      isFilterFixedMinMaxWidth
      isHighlighted={!!value}
      isSolidIcon
      label={
        value === 'true'
          ? 'Connected'
          : 'Connection status'
      }
    >
      {
        value === 'true'
          ? 'Connected'
          : 'Connection status'
      }
    </DropdownButton>

  const handerToggleChange = () => {
    const newValue = value === 'true'
      ? ''
      : 'true'

    onChange(newValue)
  }

  const renderFooter = () => (
    <div
      style={paddingStyle}
    >
      <ToggleButton
        ariaLabel='Show only connected'
        iconOff={<FaTimes aria-hidden />}
        iconOn={<FaCheck aria-hidden />}
        isOn={value === 'true'}
        label='Show only connected'
        onChange={handerToggleChange}
      />
    </div>
  )

  return (
    <Combobox
      footer={renderFooter()}
      isFilter
      onChange={onChange}
      options={connectionOptions}
      renderButton={getRenderButton(connectionOptions)}
      value={value}
    />
  )
}

export default SelectConnectionStatus
